// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';

class Accordian {
	constructor(el) {

		// Tab window transition duration (ms)
		this.transitionDuration = 500;

		// Classes
		this.activeClass = 'is-open';

		// Elements
		this.$el = $(el);
		this.$accordianToggles = this.$el.find('.accordian-toggle');

		this.attachEvents();

		this.$el.data('init', true);
	}

	attachEvents() {

		this.$accordianToggles.on('click', (evt) => {
			let $currentTarget = $(evt.currentTarget);
			let href = $currentTarget.attr('href');

			if (typeof href !== 'undefined' && href.length) {
				evt.preventDefault();
			}

			let accordianToggleBtn = $(evt.currentTarget);
			let accordianSection = accordianToggleBtn.parent();
			let accordianExpand = accordianSection.find('.accordian-expand');
			this.toggleAccordianSection(accordianToggleBtn, accordianExpand);
		});

	}

	toggleAccordianSection(btn, content) {

		if ( !btn.hasClass(this.activeClass) ) {
			//open
			btn.addClass(this.activeClass);
			content.addClass(this.activeClass);
			content.slideDown();
		} else {
			//close
			btn.removeClass(this.activeClass);
			content.removeClass(this.activeClass);
			content.slideUp();
		}

	}
}

export default Accordian;

const _init = () => {
	// Elements
	let $el = $('.accordian-component');
	if ($el.length) {
		$el.each((e, v) => {
			if ( !$(v).data('init') ) {
				new Accordian($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function(){
	_init();
});
